<template>
    <div class="text-center">
        <v-dialog
            v-model="flags.dialog"
            width="500"
            persistent
        >
            <template v-slot:activator="{ on, attrs }">
                <slot v-bind="{ on, attrs }">
                    <v-btn
                        color="red lighten-2"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                        {{ text }}
                    </v-btn>
                </slot>
            </template>

            <v-card>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <v-card-text>
                    {{ content }}

                    <div class="mt-4">
                        <v-text-field
                            ref="passwordInput"
                            v-model="form.password"
                            type="password"
                            class="mt-1 block w-3/4"
                            placeholder="Password"
                            @keyup.enter="confirmPassword"
                        />

                        <!-- <JetInputError :message="form.error" class="mt-2" /> -->
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="red lighten-2"
                        dark
                        @click="closeModal"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        color="primary"
                        class="ml-3"
                        :loading="form.processing"
                        :disabled="form.processing"
                        @click="confirmPassword"
                    >
                        {{ button }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        text: {
            type: String,
            default: 'Enable'
        },
        title: {
            type: String,
            default: 'Confirm Password',
        },
        content: {
            type: String,
            default: 'For your security, please confirm your password to continue.',
        },
        button: {
            type: String,
            default: 'Confirm',
        },
    },

    data() {
        return {
            flags: {
                dialog: false,
            },
            form: this.$inertia.form({
                password: '',
                error: '',
                processing: false,
            }),
            passwordInput: null,
        };
    },

    methods: {
        startConfirmingPassword() {
            axios.get(route('password.confirmation')).then(response => {
                if (_.get(response, 'data.confirmed')) {
                    this.$emit('confirmed');
                    this.closeModal();
                } else {
                    this.flags.dialog = true;

                    setTimeout(() => this.$refs.passwordInput.focus(), 250);
                }
            });
        },

        confirmPassword() {
            this.form.processing = true;

            axios.post(route('password.confirm'), {
                password: this.form.password,
            }).then(() => {
                this.form.processing = false;

                this.closeModal();

                this.$nextTick(() => this.$emit('confirmed'))
            }).catch(error => {
                this.form.processing = false;
                this.form.error = error.response.data.errors.password[0];
                this.$refs.passwordInput.focus();
            });
        },

        closeModal() {
            this.flags.dialog = false;
            this.form.password = '';
            this.form.error = '';
        },
    },

    watch: {
        'flags.dialog': {
            handler(value) {
                if(value){
                    this.startConfirmingPassword();
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
